export const LOCAL_STORAGE_KEYS = {
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  PHONE_MIC_DEVICE: 'phoneMicDevice',
  PHONE_SPEAKER_DEVICE: 'phoneSpeakerDevice',
  PHONE_MIC_DEVICE_LABEL: 'phoneMicDeviceLabel',
  PHONE_SPEAKER_DEVICE_LABEL: 'phoneSpeakerDeviceLabel',
};
